<template>
  <div class="open_shipments">
    <div style="margin:10px;">
      <v-row>
        <v-col cols="12">
          <v-card height="350px" elevation="12">
            <v-card-title>
              <v-row>
                <v-col col="6">Open Shipments</v-col>
                <v-col col="6">
                  <v-text-field
                    label="Search..."
                    variant="solo"
                    density="compact"
                    hide-details="true"
                    @input="debouncedOpenShipmentsSearch($event)"
                    style="width:250px;float:right"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <Vue3EasyDataTable
                :headers="open_shipments_headers"
                :items="open_shipments_table_data"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="245"
                :search-value="searchOpenShipments"
              >
                <template #item-sales_order_number="item">
                  <span class="dashboard-link" @click="openSalesOrderDetailPopup(item.sales_order_number)">
                    {{ item.sales_order_number }}
                  </span>
                  <div
                    v-if="item.white_glove_support_order"
                    style="background: yellow;text-align: center;font-size:8px;line-height:150%;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;margin-bottom:2px"
                  >
                    WHITE GLOVE ORDER
                  </div>
                  <div
                    v-if="item.white_glove_tracking_for_this_ship_to"
                    style="background: lightyellow;text-align: center;line-height:150%;font-size:8px;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;"
                  >
                    WHITE GLOVE ADDRESS
                  </div>
                </template>

                <template #item-group_shipment_id_sortable="item">
                  {{ item.group_shipment_id }}
                </template>

                <template #item-sales_order_eta_sortable="item">
                  {{ item.sales_order_eta_formatted }}
                </template>

                <template #item-sales_order_eta_last_updated_sortable="item">
                  {{ item.sales_order_eta_last_updated_formatted }}
                </template>

                <template #item-order_date_sortable="item">
                  {{ item.order_date_formatted }}
                </template>

                <template #item-ship_date_sortable="item">
                  {{ item.ship_date_formatted }}
                </template>

                <template #item-internal_notes="item">
                  <div
                    v-for="n in item.internal_notes"
                    :key="n.submitted_date + n.submitted_by_name + n.note"
                    style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;width:200px"
                  >
                    <div style="font-style:italic">{{ n.note }}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">
                      submitted {{ formatDate(n.submitted_date) }} by {{ n.submitted_by_name }}
                    </div>
                  </div>
                </template>
              </Vue3EasyDataTable>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card height="350px" elevation="12">
            <v-card-title>
              <v-row>
                <v-col col="6">
                  Recently Closed Shipments (shipping status marked 'Complete' in the last 10 days)
                </v-col>
                <v-col col="6">
                  <v-text-field
                    label="Search..."
                    variant="solo"
                    density="compact"
                    hide-details="true"
                    @input="debouncedClosedShipmentsSearch($event)"
                    style="width:250px;float:right"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <Vue3EasyDataTable
                :headers="recently_closed_shipments_headers"
                :items="recently_closed_shipments_table_data"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="245"
                :search-value="searchClosedShipments"
              >
                <template #item-sales_order_number="item">
                  <span class="dashboard-link" @click="openSalesOrderDetailPopup(item.sales_order_number)">
                    {{ item.sales_order_number }}
                  </span>
                  <div
                    v-if="item.white_glove_support_order"
                    style="background: white;text-align: center;font-size:8px;line-height:150%;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;margin-bottom:2px"
                  >
                    WHITE GLOVE ORDER
                  </div>
                  <div
                    v-if="item.white_glove_tracking_for_this_ship_to"
                    style="background: white;text-align: center;font-size:8px;line-height:150%;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;"
                  >
                    WHITE GLOVE ADDRESS
                  </div>
                </template>

                <template #item-group_shipment_id_sortable="item">
                  {{ item.group_shipment_id }}
                </template>

                <template #item-sales_order_eta_sortable="item">
                  {{ item.sales_order_eta_formatted }}
                </template>

                <template #item-sales_order_eta_last_updated_sortable="item">
                  {{ item.sales_order_eta_last_updated_formatted }}
                </template>

                <template #item-order_date_sortable="item">
                  {{ item.order_date_formatted }}
                </template>

                <template #item-shipping_status_complete_timestamp_sortable="item">
                  {{ item.shipping_status_complete_timestamp_formatted }}
                </template>

                <template #item-ship_date_sortable="item">
                  {{ item.ship_date_formatted }}
                </template>

                <template #item-internal_notes="item">
                  <div
                    v-for="n in item.internal_notes"
                    :key="n.submitted_date + n.submitted_by_name + n.note"
                    style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;width:200px"
                  >
                    <div style="font-style:italic">{{ n.note }}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">
                      submitted {{ formatDate(n.submitted_date) }} by {{ n.submitted_by_name }}
                    </div>
                  </div>
                </template>
              </Vue3EasyDataTable>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <PurchaseOrderDetailPopUp
      v-if="po_detail"
      :po="po_for_component"
      @close="closePurchaseOrderDetailPopup()"
    />
    <SalesOrderDetailPopUp
      v-if="sales_order_detail"
      :sales_order="sales_order_for_component"
      @close="closeSalesOrderDetailPopup()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-business-days'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import PurchaseOrderDetailPopUp from '@/components/PurchaseOrderDetailPopUp.vue'
import SalesOrderDetailPopUp from '@/components/SalesOrderDetailPopUp.vue'
import { debounce } from 'lodash'
import { getDatabase, ref, onChildAdded, onChildChanged, onChildRemoved } from 'firebase/database'

export default {
  name: 'OpenShipments',
  components: { Vue3EasyDataTable, PurchaseOrderDetailPopUp, SalesOrderDetailPopUp },
  data() {
    return {
      open_shipments_headers: [
        { text: 'Sales Order Number', value: 'sales_order_number', sortable: true },
        { text: 'Customer', value: 'customer_name', sortable: true },
        { text: 'Sales Order Date', value: 'order_date_sortable', sortable: true },
        { text: 'Shipping Status', value: 'status', sortable: true },
        { text: 'Ship Date', value: 'ship_date_sortable', sortable: true },
        { text: 'Ship To City', value: 'ship_to_city', sortable: true },
        { text: 'Shipping Company', value: 'shipping_company', sortable: true },
        { text: 'Ship Via Code', value: 'ship_via_code', sortable: true },
        { text: 'Tracking Number', value: 'tracking_number', sortable: true },
        { text: 'Group Shipment ID', value: 'group_shipment_id_sortable', sortable: true },
        { text: 'Complete Order Status', value: 'complete_order_status', sortable: true },
        { text: 'Sales Order ETA', value: 'sales_order_eta_sortable', sortable: true },
        { text: 'Sales Order ETA Last Updated', value: 'sales_order_eta_last_updated_sortable', sortable: true },
        { text: 'Sales Order Internal Notes', value: 'internal_notes', sortable: true }
      ],
      recently_closed_shipments_headers: [
        { text: 'Sales Order Number', value: 'sales_order_number', sortable: true },
        { text: 'Customer', value: 'customer_name', sortable: true },
        { text: 'Sales Order Date', value: 'order_date_sortable', sortable: true },
        { text: 'Shipment Closed Date', value: 'shipping_status_complete_timestamp_sortable', sortable: true },
        { text: 'Ship Date', value: 'ship_date_sortable', sortable: true },
        { text: 'Ship To City', value: 'ship_to_city', sortable: true },
        { text: 'Shipping Company', value: 'shipping_company', sortable: true },
        { text: 'Ship Via Code', value: 'ship_via_code', sortable: true },
        { text: 'Tracking Number', value: 'tracking_number', sortable: true },
        { text: 'Group Shipment ID', value: 'group_shipment_id_sortable', sortable: true },
        { text: 'Complete Order Status', value: 'complete_order_status', sortable: true },
        { text: 'Sales Order ETA', value: 'sales_order_eta_sortable', sortable: true },
        { text: 'Sales Order ETA Last Updated', value: 'sales_order_eta_last_updated_sortable', sortable: true },
        { text: 'Sales Order Internal Notes', value: 'internal_notes', sortable: true }
      ],
      searchOpenShipments: '',
      searchClosedShipments: '',
      po_detail: false,
      sales_order_detail: false,
      po_for_component: null,
      sales_order_for_component: null,
      table_height: 200,
      open_shipments_table_data: [],
      recently_closed_shipments_table_data: [],
      salesOrdersAddedUnsub: null,
      salesOrdersChangedUnsub: null,
      salesOrdersRemovedUnsub: null
    }
  },
  computed: {
    ...mapGetters(['user', 'db'])
  },
  beforeMount() {
    if (this.user === 'vendor' || !this.user) {
      this.$router.push('/')
    }
    this.table_height = 400
  },
  created() {
    window.addEventListener('resize', this.sizeTable)
    this.initSalesOrderListeners()
  },
  destroyed() {
    window.removeEventListener('resize', this.sizeTable)
    if (this.salesOrdersAddedUnsub) this.salesOrdersAddedUnsub()
    if (this.salesOrdersChangedUnsub) this.salesOrdersChangedUnsub()
    if (this.salesOrdersRemovedUnsub) this.salesOrdersRemovedUnsub()
  },
  methods: {
    debouncedOpenShipmentsSearch: debounce(function (event) {
      this.searchOpenShipments = event.target._value.replace(/\*/g, '')
    }, 500),
    debouncedClosedShipmentsSearch: debounce(function (event) {
      this.searchClosedShipments = event.target._value.replace(/\*/g, '')
    }, 500),
    initSalesOrderListeners() {
      const db = getDatabase()
      const salesOrdersRef = ref(db, 'sales_orders')

      this.salesOrdersAddedUnsub = onChildAdded(salesOrdersRef, snapshot => {
        const val = snapshot.val()
        if (!val) return
        const so = this.decorateSalesOrder(val, snapshot.key)
        this.updateSalesOrderMembership(so)
      })

      this.salesOrdersChangedUnsub = onChildChanged(salesOrdersRef, snapshot => {
        const val = snapshot.val()
        if (!val) return
        const so = this.decorateSalesOrder(val, snapshot.key)
        this.updateSalesOrderMembership(so)
        console.log(so)
      })

      this.salesOrdersRemovedUnsub = onChildRemoved(salesOrdersRef, snapshot => {
        const id = snapshot.key
        this.removeSalesOrderFromAllLists(id)
      })
    },
    decorateSalesOrder(sales_order, id) {
      const so = { ...sales_order }
      so.id = id

      const orderDate = so.sales_order_date
      if (orderDate) {
        so.order_date_sortable = Moment(orderDate).startOf('day')
        so.order_date_formatted = this.formatDate(so.order_date_sortable)
      } else {
        so.order_date_sortable = 999
        so.order_date_formatted = ''
      }

      if (so.ship_date) {
        so.ship_date_sortable = Moment(so.ship_date).startOf('day')
        so.ship_date_formatted = this.formatDate(so.ship_date_sortable)
      } else {
        so.ship_date_sortable = 999
        so.ship_date_formatted = ''
      }

      so.has_shipping_data =
        (so.shipping_company && so.shipping_company.trim().length > 0) ||
        (so.tracking_number && so.tracking_number.trim().length > 0)

      if (so.eta) {
        so.sales_order_eta_sortable = Moment(so.eta).startOf('day')
        so.sales_order_eta_formatted = this.formatDate(so.sales_order_eta_sortable)
      } else {
        so.sales_order_eta_sortable = 999
        so.sales_order_eta_formatted = ''
      }

      if (so.eta_last_updated) {
        so.sales_order_eta_last_updated_sortable = Moment(so.eta_last_updated).startOf('day')
        so.sales_order_eta_last_updated_formatted = this.formatDate(so.sales_order_eta_last_updated_sortable)
      } else {
        so.sales_order_eta_last_updated_sortable = 999
        so.sales_order_eta_last_updated_formatted = ''
      }

      so.group_shipment_id_sortable = this.normalizeForSorting(so.group_shipment_id)
      so.status = so.custom_shipping_status || (so.ship_date ? 'In Transit' : 'Not Yet Shipped')

      so.internal_notes_flat = so.internal_notes
        ? Object.values(so.internal_notes)
            .map(n => `${n.note ?? ''} ${n.submitted_by_name ?? ''}`)
            .join(' ')
        : ''

      if (so.status === 'Complete' && so.shipping_status_complete_timestamp) {
        so.shipping_status_complete_timestamp_sortable = Moment(so.shipping_status_complete_timestamp).startOf('day')
        so.shipping_status_complete_timestamp_formatted = this.formatDate(
          so.shipping_status_complete_timestamp_sortable
        )
      }

      if (so.completed_date) {
        so.completed_date_sortable = Moment(so.completed_date).startOf('day')
        so.completed_date_formatted = this.formatDate(so.completed_date_sortable)
      }

      return so
    },
    isOpenShipment(so) {
      // old logic:
      // return so.has_shipping_data && so.status !== 'Complete' && so.file_provided_drop_ship !== 'Y'

      // new logic (slack on 3/3/26 12:29pm:
        // manual shipping status is NOT “complete”
        // complete order status field includes “S” (this indicates ship confirmed) at any point in time
        // Drop Ship field is not “Y” (some fields are blank, some are “N”)
        // sales order date of 3/1/2026 or later
        // ship via code ['08','10','11','14','15','16','17','22','VMI','VMI+']
        


      return so.custom_shipping_status !== 'Complete' && 
             (
               so.complete_order_status?.split(',').includes('S') ||
               Object.values(so.complete_order_status_history || {}).some(h => h.split(',').includes('S'))
             ) &&
             so.file_provided_drop_ship !== 'Y' && 
             Moment(so.sales_order_date, 'M/DD/YY').isSameOrAfter(Moment('2026-03-01')) &&
             ['08','10','11','14','15','16','17','22','VMI','VMI+'].includes(so.ship_via_code)
    },
    isRecentlyClosedShipment(so) {
      if (so.status !== 'Complete' || !so.shipping_status_complete_timestamp) return false
      const tenDaysAgo = Date.now() - 10 * 24 * 60 * 60 * 1000
      return so.shipping_status_complete_timestamp >= tenDaysAgo
    },
    updateArrayMembership(list, item, shouldBeInList) {
      const index = list.findIndex(i => i.id === item.id)
      if (shouldBeInList) {
        if (index === -1) {
          list.push(item)
        } else {
          list.splice(index, 1, item)
        }
      } else if (index !== -1) {
        list.splice(index, 1)
      }
    },
    updateSalesOrderMembership(so) {
      const open = this.isOpenShipment(so)
      const closed = this.isRecentlyClosedShipment(so)
      this.updateArrayMembership(this.open_shipments_table_data, so, open)
      this.updateArrayMembership(this.recently_closed_shipments_table_data, so, closed)
    },
    removeSalesOrderFromAllLists(id) {
      const lists = [this.open_shipments_table_data, this.recently_closed_shipments_table_data]
      lists.forEach(list => {
        const index = list.findIndex(i => i.id === id)
        if (index !== -1) list.splice(index, 1)
      })
    },
    normalizeForSorting(value) {
      if (!value) return 'ZZZZZZ'
      const match = value.match(/^(\d+)(.*)$/)
      if (!match) return value
      const numPart = match[1].padStart(10, '0')
      const suffix = match[2] || ''
      return `${numPart}${suffix}`
    },
    openPurchaseOrderDetailPopup(po) {
      this.po_for_component = po
      this.po_detail = true
    },
    closePurchaseOrderDetailPopup() {
      this.po_for_component = null
      this.po_detail = false
    },
    openSalesOrderDetailPopup(sales_order) {
      this.sales_order_for_component = sales_order
      this.sales_order_detail = true
    },
    closeSalesOrderDetailPopup() {
      this.sales_order_for_component = null
      this.sales_order_detail = false
    },
    isDateString(str) {
      return typeof str === 'string' && (str.match(/\//g) || []).length === 2
    },
    sizeTable() {
      this.table_height = window.innerHeight - 260
    },
    formatDate(date) {
      return Moment(date).format('MM/DD/YY')
    },
    formatDateTime(date) {
      return Moment(date).format('MM/DD/YY hh:mma')
    }
  }
}
</script>

<style scoped>
.v-card .v-card-title {
  color: gray;
  font-size: 14px;
}

.v-card .v-card-text {
  line-height: 100%;
}

.v-card-actions {
  min-height: 0px;
  padding: 4px 0px;
}

.dashboard-link {
  color: #ff7214;
  cursor: pointer;
  font-weight: bold;
  font-size: 11px;
}
</style>
